import { DialogContent, useMediaQuery, useTheme } from '@mui/material'
import DialogActions from '@mui/material/DialogActions'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useDeleteReflinkMutation } from 'shared/store/useClientReflinks'
import ContainedButton from 'shared/components/Buttons/ContainedButton'
import OutlinedButton from 'shared/components/Buttons/OutlinedButton'

interface Props {
   reflinkUuid: string
   handleClose: () => void
}

export default function DeleteReflinkModalContent({ reflinkUuid, handleClose }: Props) {
   const { mutate } = useDeleteReflinkMutation()
   const { t } = useTranslation(['TRANSLATION', 'CLIENTS_CARTS'])
   const theme = useTheme()
   const isMobile = useMediaQuery(theme.breakpoints.down('md'))

   function handleDelete() {
      mutate(reflinkUuid, {
         onSuccess: handleClose,
      })
   }

   return (
      <>
         {isMobile && <DialogContent />}
         <DialogActions>
            <OutlinedButton isDelete variant="outlined" onClick={handleClose}>
               {t('TRANSLATION:no')}
            </OutlinedButton>
            <ContainedButton isDelete onClick={handleDelete} variant="contained">
               {t('TRANSLATION:yes')}
            </ContainedButton>
         </DialogActions>
      </>
   )
}
